import React from 'react';

class EnergyGenerator extends React.Component {
  onDragStart = (event) => {
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text', JSON.stringify(this.props));
    this.props.props.type = '01';
    return true;
  };

  render() {
    return (
      <div
        className="energy-generator"
        draggable="true"
        onDragStart={this.onDragStart}
      >
        {}
      </div>
    );
  }
}

export { EnergyGenerator };
